// extracted by mini-css-extract-plugin
export default {"story":"StoryPetition_story__o5YgS"};